var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTabSelectIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "300px",
    height: "300px",
    viewBox: "0 0 300 300",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "smart_button-24px",
    transform: "translate(52.000000, 129.000000)",
    fill: "#62A8AC",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196,8.6 L196,34.4 C196,39.13 192.064194,43 187.253763,43 L182.880645,43 L182.880645,35.4487805 L188.307527,35.4487805 L188.307527,7.55121951 L7.69247312,7.55121951 L7.69247312,35.4487805 L182.880645,35.4487805 L182.880645,43 L8.74623656,43 C3.93580645,43 0,39.13 0,34.4 L0,8.6 C0,3.87 3.93580645,0 8.74623656,0 L187.253763,0 C192.064194,0 196,3.87 196,8.6 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 117,
    y: 13,
    width: 66,
    height: 17,
    rx: 2
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTabSelectIcon);
export default __webpack_public_path__ + "static/media/tabSelectIcon.772eef5d39ff49df6f627602a5f2d2b8.svg";
export { ForwardRef as ReactComponent };